import { render, staticRenderFns } from "./AtomImageResponsive.vue?vue&type=template&id=2793ae38&scoped=true"
import script from "./AtomImageResponsive.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomImageResponsive.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793ae38",
  null
  
)

export default component.exports